export const ACTION_SET_BALANCE = "ACTION_SET_BALANCE"
export const ACTION_SET_ACTIVE_PAYMENTS = "ACTION_SET_ACTIVE_PAYMENTS"
export const ACTION_SET_PLANS = "ACTION_SET_PLANS"
export const ACTION_SET_COMISSION = "ACTION_SET_COMISSION"
export const ACTION_SET_GRAPH = "ACTION_SET_GRAPH"